import './CandidateJobPostingModal.scss';

import { Modal, Button, Form } from "react-bootstrap";
import { useState, useEffect } from "react";
import { api } from '../../../utils/api';

function formatDateForInput(dateString) {
  if (!dateString) return "";
  const d = new Date(dateString);
  if (isNaN(d)) return "";
  return d.toISOString().split("T")[0]; // keeps only YYYY-MM-DD
}

function createInitialFormDataState(job = null) {
  return {
    title:          job?.title          || "",
    description:    job?.description    || "",
    location:       job?.location       || "",
    author:         job?.author         || "",
    budget:         job?.budget         || "",
    genre:          job?.genre          || "",
    post_url:       job?.post_url       || "",
    tags:           job?.tags           || "",
    posted_at:      formatDateForInput(job?.posted_at),
    expires_at:     formatDateForInput(job?.expires_at),
  };
}

export default function JobPostingModal({ show, handleClose, job, jobs, setJobs }) {
  const [formData, setFormData] = useState(createInitialFormDataState());

  // Load job into form when editing
  useEffect(() => {
    setFormData(createInitialFormDataState(job));
  }, [job]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    // Convert empty strings to null and remove undefined
    const payload = {};
    Object.entries(formData).forEach(([key, value]) => {
      if (value !== "" && value !== undefined) {
        payload[key] = value;
      } else {
        payload[key] = null;
      }
    });

    setJobs(prevJobs =>
      prevJobs.map(j => (j.id === job.id ? { ...j, ...payload } : j))
    );
    api.put(`/candidate_job_postings/${job.id}`, payload);

    handleClose();
  };

  return (
    <Modal className="__candidate-job-posting-modal" show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{job ? "Edit Job Posting" : "Create Job Posting"}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Author</Form.Label>
            <Form.Control
              name="author"
              value={formData.author}
              onChange={handleChange}
              placeholder="Enter author"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Title</Form.Label>
            <Form.Control
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="Enter job title"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Enter job description"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Location</Form.Label>
            <Form.Control
              name="location"
              value={formData.location}
              onChange={handleChange}
              placeholder="Enter location"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Expires At</Form.Label>
            <Form.Control
              type="date"
              name="expires_at"
              value={formData.expires_at}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Posted At</Form.Label>
            <Form.Control
              type="date"
              name="posted_at"
              value={formData.posted_at}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Budget</Form.Label>
            <Form.Control
              type="number"
              name="budget"
              value={formData.budget}
              onChange={handleChange}
              placeholder="Enter budget"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Genre</Form.Label>
            <Form.Control
              name="genre"
              value={formData.genre}
              onChange={handleChange}
              placeholder="Enter genre"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Post URL</Form.Label>
            <Form.Control
              name="post_url"
              value={formData.post_url}
              onChange={handleChange}
              placeholder="Enter original post URL"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Tags</Form.Label>
            <Form.Control
              name="tags"
              value={formData.tags}
              onChange={handleChange}
              placeholder="Enter tags"
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button className="ppy-btn ppy-btn-tertiary" onClick={handleClose}>
          Cancel
        </Button>
        <Button className="ppy-btn ppy-btn-primary" onClick={handleSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
}